import React, { useState, useRef, useEffect } from "react";

import styled from "styled-components";
import { useSelector } from "react-redux";
import { selectSecondeColor } from "../../features/counter/counterSlice";

const MessagesContainer = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  background-color: black;
`;

const MessageBubble = styled.div`
  max-width: 70%;
  padding: 12px 16px;
  margin: 8px 0;
  border-radius: 18px;
  background-color: ${({ isUser, secondeColor }) =>
    isUser ? `rgb(${secondeColor})` : "#e5e5ea"};
  color: ${({ isUser }) => (isUser ? "white" : "black")};
  align-self: ${({ isUser }) => (isUser ? "flex-end" : "flex-start")};
  white-space: pre-wrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  overflow-wrap: break-word;
  word-break: break-word;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  /* border-top: 1px solid #ccc; */
  margin: 1rem;
  background-color: rgb(41, 41, 41);
  border-radius: 16px;
  border: 1px solid #000;

  &:hover {
    border: 1px solid #ccc;
  }
`;

const Input = styled.textarea`
  flex: 1;
  padding: 3px;
  border: 1px solid rgb(41, 41, 41);
  border-radius: 16px;
  outline: none;
  background-color: rgb(41, 41, 41);
  height: auto;
  color: white;
  resize: none;
  line-height: 15px;
  max-height: 158px;
`;

const Button = styled.button`
  margin-left: 12px;
  padding: 12px 20px;
  /* background-color: #007bff; */
  background-color: ${({ secondeColor }) => `rgb(${secondeColor})`};
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background-color: #0056b3;
  }
`;
const ChatContainer = styled.div`
  position: fixed;
  max-width: 800px;
  width: 400px;
  height: 55vh;
  right: 30px;
  bottom: 100px;
  margin: auto;
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 16px;
  overflow: hidden;
  border: 2px solid ${({ secondeColor }) => `rgb(${secondeColor})`};
  z-index: 1000;
  background-color: black;
  font-size: 14px;
`;
// const key = generateKey();

function Chatbot() {
  const secondeColor = useSelector(selectSecondeColor);

  const [showDiv, setShowDiv] = useState(false);
  const [displayedDiv, setDisplayedDiv] = useState(false);
  const divRef = useRef(null);
  const [lienPdf, setLienPdf] = useState(null);
  const containerRef = useRef();

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;
    setInput("");
    const newMessages = [...messages, { role: "user", content: input }];
    setMessages(newMessages);
    setIsLoading(true); // Démarre le loader

    try {
      const res = await fetch("https://lumfo.com/api/ai/chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_TOKEN_API_RESUME_AGENT_IA}`, // token JWT
        },
        body: JSON.stringify({ message: input, history: messages }),
      });
      const data = await res.json();

      setMessages([...newMessages, { role: "assistant", content: data.reply }]);
    } catch (error) {
      setMessages([
        ...newMessages,
        {
          role: "assistant",
          content: "Erreur lors de la requête. Veuillez réessayer.",
        },
      ]);
    } finally {
      setIsLoading(false); // Stop le loader
      setInput("");
    }
  };
  // Scroll automatique vers le bas quand messages ou loading changent
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages, isLoading]);
  return (
    <>
      <ChatContainer secondeColor={secondeColor}>
        <MessagesContainer ref={containerRef}>
          {messages.map((m, i) => (
            <MessageBubble
              key={i}
              isUser={m.role === "user"}
              secondeColor={secondeColor}
            >
              {m.content}
            </MessageBubble>
          ))}
          {isLoading && (
            <MessageBubble isUser={false}>
              {/* Ici tu peux mettre une animation, du texte ou un spinner */}
              <em>Dimitri réfléchit...</em>
            </MessageBubble>
          )}
        </MessagesContainer>
        <InputContainer>
          <Input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Posez une question à Dimitri..."
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <div className="footerChatbot">
            <div className="boutonsChatbot"></div>
            <div className="videChatbot"></div>
            <div
              className="envoiBoutonChatbot"
              secondeColor={secondeColor}
              onClick={sendMessage}
            >
              <svg width="24" height="24" viewBox="0 0 512 512" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  transform="scale(64)"
                  fill="#8d8d8d"
                />
                <circle fill="#8d8d8d" cx="254" cy="254" r="254" />
                <g transform="translate(80, 100) scale(22)">
                  <path
                    fill="#000000"
                    // fill="currentColor"
                    fill-rule="evenodd"
                    d="M7.4 1.899a.85.85 0 0 1 1.201 0l4.5 4.5A.85.85 0 1 1 11.9 7.6L8.85 4.552V13.5a.85.85 0 0 1-1.7 0V4.552L4.101 7.601A.85.85 0 1 1 2.9 6.399z"
                    clip-rule="evenodd"
                  ></path>
                </g>
              </svg>
              {/* Envoyer */}
            </div>
          </div>
        </InputContainer>
      </ChatContainer>
    </>
  );
}

export default Chatbot;
